import Magazine from "../components/collection/magazine";
import { Breakpoint } from "../utils/media-query";

const AulabCatalogueJuly = () => {
  const [isDesktop, isTablet, isMobile] = Breakpoint();

  return (
    <>
      <div className={isDesktop ? "container" : "container-mobile"}>
        <Magazine src="https://e.issuu.com/embed.html?backgroundColor=%23ffffff&backgroundColorFullscreen=%23ffffff&d=catalogue_july&hideIssuuLogo=true&hideShareButton=true&u=aurumlab" />
      </div>
    </>
  );
};
export default AulabCatalogueJuly;
